var p = Object.defineProperty;
var r = (e, t, n) => t in e ? p(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var i = (e, t, n) => r(e, typeof t != "symbol" ? t + "" : t, n);
import { HttpClient as a, httpClient as s } from "../../httpClient.js";
class c extends a {
  constructor() {
    super(...arguments);
    i(this, "endpoint", "/announcements");
  }
  async getAll() {
    return s.get(this.endpoint);
  }
  async getOne(n) {
    return s.get(`${this.endpoint}/${n}`);
  }
  async create(n) {
    return s.post(this.endpoint, n);
  }
  async update(n, o) {
    return s.put(`${this.endpoint}/${n}`, o);
  }
  async remove(n) {
    return s.delete(`${this.endpoint}/${n}`);
  }
}
const l = new c();
export {
  l as default
};
